import deliveryQueries from "./solutions/delivery-queries.json";
import cancelOrder from "./solutions/cancel-order.json";
import generalDeliveryQueries from "./solutions/general-delivery-queries.json";
import helpWithDeliveryProblem from "./solutions/help-with-delivery-problem.json";
import itemDamagedOnDelivery from "./solutions/item-damaged-on-delivery.json";
import helpWithDeliveryProblemOther from "./solutions/help-with-delivery-problem-other.json";
import makingChangesToMyDelivery from "./solutions/making-changes-to-my-delivery.json";
import trackMyOrder from "./solutions/track-my-order.json";
import guarantees from "./solutions/problems-with-product-guarantees.json";
import productStockInformation from "./solutions/product-stock-information.json";
import productStockInformationCheckInStore from "./solutions/product-stock-information-check-in-store.json";
import productStockInformationOutStock from "./solutions/product-stock-information-out-stock.json";
import productStockInformationOutStockOptions from "./solutions/product-stock-information-out-stock-options.json";
import productStockInformationOutStockOther from "./solutions/product-stock-information-out-stock-other.json";
import productStockInformationOutStockElectrical from "./solutions/product-stock-information-out-stock-electrical.json";
import productStockInformationOutStockTv from "./solutions/product-stock-information-out-stock-tv.json";
import productStockInformationProductInfo from "./solutions/product-stock-information-product-info.json";
import productStockInformationHelp from "./solutions/product-stock-information-help.json";
import productStockInformationDelivery from "./solutions/product-stock-information-delivery.json";
import productStockInformationPriceMatch from "./solutions/product-stock-information-price-match.json";
import productStockInformationOther from "./solutions/product-stock-information-other.json";
import returnsAndRefunds from "./solutions/returns-and-refunds.json";
import generalPolicyQuestions from "./solutions/general-policy-questions.json";
import refunds from "./solutions/refunds.json";
import refundsJL from "./solutions/refunds-jl.json";
import refundsWaitrose from "./solutions/refunds-waitrose.json";
import refundsWaitroseTwoWeeks from "./solutions/refunds-waitrose-two-weeks.json";
import refundsRoyalMail from "./solutions/refunds-royal-mail.json";
import refundsRoyalMailTwoWeeks from "./solutions/refunds-royal-mail-two-weeks.json";
import refundsDobbiesShellSelect from "./solutions/refunds-dobbies-shell-select.json";
import refundsDobbiesShellSelectTwoWeeks from "./solutions/refunds-dobbies-shell-select-two-weeks.json";
import refundsBooths from "./solutions/refunds-booths.json";
import refundsBoothsTwoWeeks from "./solutions/refunds-booths-two-weeks.json";
import refundsCollectedJL from "./solutions/refunds-collected-jl.json";
import refundsCollectedJLTwoWeeks from "./solutions/refunds-collected-jl-two-weeks.json";
import refundsWithinTwoWeeks from "./solutions/refunds-within-two-weeks.json";
import refundsOverTwoWeeks from "./solutions/refunds-over-two-weeks.json";
import returningOrExchanging from "./solutions/returning-or-exchanging.json";
import problemsWithProduct from "./solutions/problems-with-product.json";
import other from "./solutions/other.json";
import electrical from "./solutions/electrical.json";
import vax from "./solutions/vax.json";
import fitbit from "./solutions/fitbit.json";
import nespresso from "./solutions/nespresso.json";
import dyson from "./solutions/dyson.json";
import placeEditCancelOrder from "./solutions/place-edit-cancel-order.json";
import myAccountOnline from "./solutions/my-account-online.json";
import myJLMembership from "./solutions/my-jl-membership.json";
import repairUpdateElectricalItem from "./solutions/repair-update-electrical-item.json";
import rebound from "./solutions/rebound.json";
import overThirtyDays from "./solutions/over-thirty-days.json";
import brandOther from "./solutions/brand-other";
import thirtyDaysOrLess from "./solutions/thirty-days-or-less";
import { getContactUsWithTVAndLaptopSupportConfig } from "./solutions/contact-us-with-tv-laptop-support";
import { getContactUsWithElectricalProductSupportConfig } from "./solutions/contact-us-with-electrical-product-support";

export default {
  contactUsWithTVLaptopSupport: getContactUsWithTVAndLaptopSupportConfig(),
  contactUsWithElectricalProductSupport: getContactUsWithElectricalProductSupportConfig(),
  deliveryQueries,
  cancelOrder,
  generalDeliveryQueries,
  helpWithDeliveryProblem,
  itemDamagedOnDelivery,
  helpWithDeliveryProblemOther,
  makingChangesToMyDelivery,
  trackMyOrder,
  guarantees,
  productStockInformation,
  productStockInformationCheckInStore,
  productStockInformationOutStock,
  productStockInformationOutStockOptions,
  productStockInformationOutStockOther,
  productStockInformationOutStockElectrical,
  productStockInformationOutStockTv,
  productStockInformationProductInfo,
  productStockInformationHelp,
  productStockInformationDelivery,
  productStockInformationPriceMatch,
  productStockInformationOther,
  returnsAndRefunds,
  generalPolicyQuestions,
  refunds,
  refundsJL,
  refundsWaitrose,
  refundsWaitroseTwoWeeks,
  refundsRoyalMail,
  refundsRoyalMailTwoWeeks,
  refundsDobbiesShellSelect,
  refundsDobbiesShellSelectTwoWeeks,
  refundsBooths,
  refundsBoothsTwoWeeks,
  refundsCollectedJL,
  refundsCollectedJLTwoWeeks,
  refundsWithinTwoWeeks,
  refundsOverTwoWeeks,
  returningOrExchanging,
  problemsWithProduct,
  other,
  electrical,
  thirtyDaysOrLess: thirtyDaysOrLess(),
  overThirtyDays,
  vax,
  fitbit,
  nespresso,
  brandOther: brandOther(),
  dyson,
  placeEditCancelOrder,
  myAccountOnline,
  myJLMembership,
  repairUpdateElectricalItem,
  rebound,
};
